import { Component, input } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Project, Assessment } from '../models';

@Component({
  selector: 'app-home',
  imports: [RouterOutlet],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home {
  readonly projects = input.required<Project[]>();
  readonly assessments = input.required<Assessment[]>();
}
